import { Link } from "react-router-dom";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  linkTo?: string;
  linkLabel?: string;
}

export default function SectionHeading({ eyebrow, title, desc, linkTo, linkLabel }: SectionHeadingProps) {
  return (
    <div className="w-full flex flex-col sm:flex-row sm:items-end justify-between gap-3 mb-6 md:mb-8">
      <div>
        {eyebrow && (
          <span className="inline-flex items-center gap-2 text-xs font-medium tracking-widest text-primary-600 mb-2">
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-fire-line"></i>
            </span>
            {eyebrow}
          </span>
        )}
        <h2 className="font-heading text-2xl md:text-3xl font-black text-foreground-950 tracking-tight">{title}</h2>
        {desc && <p className="mt-2 text-sm text-foreground-600 max-w-2xl">{desc}</p>}
      </div>
      {linkTo && linkLabel && (
        <Link
          to={linkTo}
          className="inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
        >
          {linkLabel}
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-arrow-right-line"></i>
          </span>
        </Link>
      )}
    </div>
  );
}